<div
  class="file-options-popup"
  ipoClickOutside
  (clickOutside)="handleClosePopup()"
>
  <gc-text class="file-name ellipsis" [textColor]="'utility'">{{
    fileName
  }}</gc-text>
  <gc-list>
    <gc-list-item
      [label]="'reportInput.remove' | translate"
      id="0"
      iconLeft="trash"
      (itemClicked)="delete.emit()"
    />
    <gc-list-item
      [label]="'reportInput.download' | translate"
      id="1"
      iconLeft="download"
      (itemClicked)="download.emit()"
    />
  </gc-list>
</div>
